var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000010303005403586168560000006196722140467469445_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110.6 115.6",
    style: {
      enableBackground: "new 0 0 110.6 115.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.9,115.6H0V18.8h21v78h70.9V115.6L91.9,115.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 91.9,
    cy: 18.8,
    r: 18.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinea);
export default __webpack_public_path__ + "static/media/linea.08d4cf10fc0fd5e985ef4b26e9bf313a.svg";
export { ForwardRef as ReactComponent };